import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "row justify-center page-height" };
const _hoisted_2 = { class: "row items-center" };
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_space = _resolveComponent("q-space");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_bar = _resolveComponent("q-bar");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createBlock(_component_general_dialog, {
        "full-screen": "",
        "lean-header": "",
        "hide-header-separator": "",
        modelValue: _ctx.fullScreen,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.fullScreen) = $event)),
        "custom-card-class": {
            'bg-black': true
        }
    }, {
        "title-toolbar": _withCtx(() => [
            _createVNode(_component_q_bar, { class: "bg-black q-my-xs" }, {
                default: _withCtx(() => [
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_btn, {
                        name: "Close",
                        flat: "",
                        round: "",
                        dense: "",
                        icon: "close",
                        color: "white",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.fullScreen = false))
                    })
                ]),
                _: 1
            })
        ]),
        "content-sections": _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("img", {
                                alt: "Confirm Send Pic",
                                src: _ctx.fileSrc,
                                class: "confirm-pic"
                            }, null, 8, _hoisted_3)
                        ])
                    ])
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
